import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheArtOfConnection from "./sections/TheArtOfConnection";
import OurSafetyStandards from "./sections/OurSafetyStandards";
import TheClayMethodology from "./sections/TheClayMethodology";
import TheIpJournal from "./sections/TheIpJournal";
import BeginYourJourney from "./sections/BeginYourJourney";
import Topdestinationsgrid from "./sections/Topdestinationsgrid";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
export default function HomePage() {
  return <div>
      <Header />
      <TheArtOfConnection />
      <OurSafetyStandards />
      <TheClayMethodology />
      <TheIpJournal />
      <Hero />
      <BeginYourJourney />
      <Topdestinationsgrid />
      <Footer />
    </div>;
}